import {
	FETCH_ADRESSES_BEGIN,
	FETCH_ADRESSES_SUCCESS,
	FETCH_ADRESSES_ERROR,
	FETCH_ADRESSES_RESET,
	FETCH_ADRESSESV2_BEGIN,
	FETCH_ADRESSESV2_SUCCESS,
	FETCH_ADRESSESV2_ERROR,
	FETCH_ADRESSESV2_RESET,
	FETCH_LOCALITES_BEGIN,
	FETCH_LOCALITES_SUCCESS,
	FETCH_LOCALITES_ERROR,
	FETCH_LOCALITES_RESET,
} from "../actions/adresseActions"

const initialState = {
	adresses: [],
	adressesv2: [],
	localites: [],
	fetchLocalites: {
		loading: false,
		error: false,
	},
	fetchAdresses: {
		loading: false,
		error: false,
	},
}

export default function adresseReducer(state = initialState, action) {
	let nextState
	switch (action.type) {
		case FETCH_LOCALITES_BEGIN:
			return {
				...state,
				fetchLocalites: {
					loading: true,
					error: false,
				},
			}
		case FETCH_LOCALITES_SUCCESS:
			return {
				...state,
				localites: action.payload,
				fetchLocalites: {
					loading: true,
					error: false,
				},
			}
		case FETCH_LOCALITES_ERROR:
			return {
				...state,
				fetchLocalites: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_LOCALITES_RESET:
			return {
				...state,
				localites: [],
				fetchLocalites: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ADRESSES_BEGIN:
			return {
				...state,
				fetchAdresses: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ADRESSES_SUCCESS:
			nextState = {
				...state,
				adresses: action.payload,
				fetchAdresses: {
					loading: false,
					error: false,
				},
			}
			return nextState

		case FETCH_ADRESSES_ERROR:
			return {
				...state,
				fetchAdresses: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ADRESSES_RESET:
			return {
				...state,
				adresses: [],
				fetchAdresses: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ADRESSESV2_BEGIN:
			return {
				...state,
				fetchAdresses: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ADRESSESV2_SUCCESS:
			nextState = {
				...state,
				adressesv2: action.payload,
				fetchAdresses: {
					loading: false,
					error: false,
				},
			}
			return nextState

		case FETCH_ADRESSESV2_ERROR:
			return {
				...state,
				fetchAdresses: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ADRESSESV2_RESET:
			return {
				...state,
				adressesv2: [],
				fetchAdresses: {
					loading: false,
					error: false,
				},
			}
		default:
			return state
	}
}
